/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {LocalKeyValueService as Éµa} from './services/local-key-value.service';